var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-preview",style:({
        backgroundColor: _vm.panelDesign.backgroundColor,
        borderColor: _vm.panelDesign.borderColor,
        borderWidth: `${_vm.panelDesign.borderSize}px`,
        borderRadius: `${_vm.panelDesign.borderRadius}px`,
        height: `${_vm.panelDesign.widgetHeight}px`,
    }),attrs:{"id":"c-preview"}},[_c('div',{staticClass:"c-preview__title",style:({
            color: _vm.panelDesign.textColor,
        })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"c-preview__content position-relative",staticStyle:{"overflow":"hidden"},attrs:{"id":"boxesID"}},[_c('vue-scrolling-ul',{style:('height: ' + `${_vm.panelDesign.widgetHeight - 143}px`),attrs:{"start":"","infinity":"","speed":20,"delay":500}},_vm._l((_vm.donates),function(donate){return _c('DonateItem',{key:donate.id,attrs:{"data":donate,"showSlamIndication":donate.is_slam,"showDedication":true,"panelDesign":_vm.panelDesign}})}),1)],1),(_vm.data.show_donate_button)?_c('button',{staticClass:"btn mt-3",style:({
            backgroundColor:
                _vm.buttonDesign.color,
            color: _vm.buttonDesign.textColor,
            borderColor:
                _vm.buttonDesign.borderColor,
            borderWidth: `${_vm.buttonDesign.borderSize}px`,
            borderRadius: `${_vm.buttonDesign.borderRadius}px`,
        }),on:{"click":_vm.donate}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }